import React from "react";
import styled from 'styled-components';

import config from "../../Config";
import PrimaryButton from "../../components/buttons/PrimaryButton";
import Storage from "../../util/Storage";

const ModalContainer = styled.div`
    display: flex;
    background-color: #ffffff;
    flex-direction: column;
    padding: 10px 15px;
    border-radius: 10px;
    margin: 0px 10px;
`;

const ModalMsg = styled.div`
    padding: 5px 15px;
    margin: 20px;
    border: 1px dashed;
    display: flex;
    border-radius: 10px;
    justify-content: space-between;
`;

const ModalHeader = styled.div`
    margin-bottom: 15px;
    font-size: 16px;
`;

const FreeBidPopup = ({count,t,hidePopup}) => {

	return <ModalContainer>
		<ModalHeader className="flex-center">
			<img width="150px" height="34px" src={`${config.BIDNWIN_S3_IMAGE_URL}/logo.png`} alt="logo"/>
		</ModalHeader>
		<ModalHeader className="flex-center montserratRegular">
			{t("CongratTitle")}
		</ModalHeader>
		<ModalMsg>
			<p className="montserratLight" style={{marginBottom: 2}}>
                {t("Youhave")}
                <span className="montserratSemiBold"> {count} {t("FreeBids")}</span>
            </p>
            <img style={{marginLeft:5}} src={`${config.BIDNWIN_S3_IMAGE_URL}/ic_auction_avatar.png`} height="75px" alt="bid-hammer"/>
		</ModalMsg>
		<div className="flex-center">
			<PrimaryButton
                label={t("StartBidding")}
                style={{
                    height: 60,
                    width: '100%'
                }}
                variant="contained"
                onClick={() => {
                    Storage.set("newUser", "false");
                    hidePopup();
                }}
            />
		</div>
	</ModalContainer>
}

export default FreeBidPopup;


// WEBPACK FOOTER //
// ./src/views/Auctions/FreeBidPopup.js